import React, { useContext } from 'react';

import { ConfigItem } from '../types';

import { ConfigItemsTrayContext } from './ConfigItemsTrayContext';
import { ConfigItemElementProps } from './types';

function ConfigItemElement({
  configItem,
  onChange,
  onRequestOptions,
  depth,
  index,
}: Readonly<ConfigItemElementProps<ConfigItem>>) {
  const context = useContext(ConfigItemsTrayContext);
  if (!context) {
    throw new Error('ConfigItemElement must be used within a ConfigItemsTrayContext.Provider');
  }

  const Element = context.configElements[configItem.type];
  if (!Element) {
    return null;
  }

  return (
    <div className="py-2" data-test-id={`config-item-${configItem.key}`}>
      <Element
        configItem={configItem}
        onChange={onChange}
        onRequestOptions={onRequestOptions}
        depth={depth ?? 0}
        index={index}
      />
    </div>
  );
}

export { ConfigItemElement };
